import { Component, OnInit, Input } from '@angular/core';

import { AppContext } from './../../shared';

@Component({
  selector: 'register-message',
  template: require('./register-message.component.html'),
  styles: [require('./register-message.component.scss')]
})

export class RegisterMessageComponent implements OnInit {
  @Input() title: string;
  @Input() content: string;

  constructor(private app: AppContext) {
    // Do stuff
  }

  ngOnInit() {
    if (this.content === '') {
      this.content = 'This feature requires a Linescape account. Please register or login now.';
    }
  }

  openLogin() {
    this.app.toggleLogin();
    this.app.hideRegister();
  }

  close() {
    this.app.hideRegister();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/message/register-message/register-message.component.ts